export default "__VITE_ASSET__6c63a5b9__"